import { useMediaQuery } from '@mui/material'
import Card from '@mui/material/Card'
import Link from '@mui/material/Link'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { isUndefined } from 'lodash'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Balance } from '../../../../components/Balance'
import { DetailsByTariffDialog } from '../../../../dialogs/DetailsByTariffDialog'
import { PromoDialog } from '../../../../dialogs/PromoDialog'
import { useProfileStore } from '../../../../store/storeProfile'
import { theme } from '../../../../theme'
import { PackagesList } from './PackagesList'

type Props = {
    isWebView?: boolean
}

export const PackageListCard: FC<Props> = ({ isWebView }) => {
    const { t } = useTranslation()
    const [openDetailsByTariffDialog, setOpenDetailsByTariffDialog] = useState<boolean>(false)
    const [openPromoDialog, setOpenPromoDialog] = useState<boolean>(false)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { tariffList, fetchTariffList, tariffListByTitle, isLoadingFetchTariffList } =
        useProfileStore((state) => state)

    useEffect(() => {
        if (isUndefined(tariffList)) {
            fetchTariffList()
        }
    }, [])

    const handleClickDetailsByTariffDialog = () => {
        setOpenDetailsByTariffDialog(true)
    }

    const handleCloseDetailsByTariffDialog = () => {
        setOpenDetailsByTariffDialog(false)
    }

    const handleClickPromoDialog = () => {
        setOpenPromoDialog(true)
    }

    const handleClosePromoDialog = () => {
        setOpenPromoDialog(false)
    }

    return (
        <>
            {(isMobile || isWebView) && (
                <Card
                    sx={{
                        borderRadius: '24px',
                        border: isWebView ? 'none': '1px solid #E9EAED',
                        p: isWebView ? '12px': '24px',
                    }}>
                    <Stack direction="column">
                        <Stack direction="row" sx={{ justifyContent: ' space-between' }}>
                            <Typography variant="body2">{t('finances.balance')}:</Typography>
                            <Link
                                color="primary"
                                onClick={() => handleClickPromoDialog()}
                                underline="hover"
                                sx={{
                                    fontSize: '14px',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    cursor: 'pointer',
                                }}>
                                {t('finances.havePromoCode')}
                            </Link>
                        </Stack>
                        <Balance isWebView={isWebView}/>
                    </Stack>
                </Card>
            )}

            <Card
                sx={{
                    borderRadius: '24px',
                    border: isWebView ? 'none': '1px solid #E9EAED',
                    p: isWebView ? '12px':'24px',
                }}>
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                    }}>
                    <span>
                        <Typography variant={isMobile ? 'h4' : 'h3'} sx={{ mb: '0.5' }}>
                            {t('finances.chooseAccessAndReplenish')}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#5A5C5E' }}>
                            {t('finances.noMonthlyCharges')}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#5A5C5E' }}>
                            {t('finances.coinsDoNotExpire')}{' '}
                            <Link
                                color="info"
                                onClick={() => handleClickDetailsByTariffDialog()}
                                variant="body2"
                                sx={{
                                    color: '#5A5C5E',
                                    textDecorationColor: '#5A5C5E',
                                    cursor: 'pointer',
                                }}>
                                {t('finances.moreDetails')}
                            </Link>
                        </Typography>
                    </span>
                    {!isMobile && !isWebView && (
                        <Link
                            color="primary"
                            onClick={() => handleClickPromoDialog()}
                            underline="hover"
                            sx={{
                                fontSize: '14px',
                                my: 3,
                                justifyContent: 'center',
                                display: 'flex',
                                cursor: 'pointer',
                            }}>
                            {t('finances.havePromoCode')}
                        </Link>
                    )}
                </Stack>

                {isLoadingFetchTariffList && (
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height="500px"
                        sx={{ borderRadius: '24px', marginTop: 3 }}
                    />
                )}

                {tariffList && <PackagesList tariffList={tariffListByTitle} />}

                {!isWebView && (
                    <Link
                        href="/setting"
                        underline="hover"
                        sx={{
                            fontSize: '14px',
                            my: 3,
                            justifyContent: 'center',
                            display: 'flex',
                            textAlign: isMobile ? 'center' : 'left',
                        }}>
                        {t('finances.moreAboutModels')}
                    </Link>
                )}
                <DetailsByTariffDialog
                    open={openDetailsByTariffDialog}
                    handleClose={handleCloseDetailsByTariffDialog}
                />
                <PromoDialog open={openPromoDialog} handleClose={handleClosePromoDialog} />
            </Card>
        </>
    )
}
